import { extraNetworkActionsCreator } from '../../../../../admincore'

const actions = {
  ...extraNetworkActionsCreator('CREATE', 'labels/create'),
}

export default actions

export function create(params) {
  return {
    type: actions.CREATE,
    payload: {
      params,
    },
  }
}
